import { FunctionComponent, useEffect } from "react";
import { QuestionIcon } from "@/form/components/common/icons";
import ShareLinkModal from "@/components/common/ShareLinkModal";
import { useState } from "react";
import { Button, CopyButton, Tooltip } from "@mantine/core";
import { Add1Icon } from "@form/components/common/icons";
import { useRouter } from "next/router";
import useAccount from "@/hooks/useAccount";

const ValidatorMintResult: FunctionComponent<{
  chainId: number;
}> = ({ chainId }) => {
  const [shareLinkOpened, setShareLinkOpened] = useState(false);
  const [shareLink, setShareLink] = useState("");
  const router = useRouter();
  const { address } = useAccount();

  useEffect(() => {
    setShareLink(window.location.href);
  }, []);

  return (
    <div className="max-w-[994px] mx-auto pb-[115px] px-5 sm:px-0 mt-10 sm:mt-[83px] animate__animated animate__fadeInUp">
      <div
        className="bg-[#EBF3FF] rounded-2xl p-4 sm:p-20 flex flex-col items-center"
        style={{
          boxShadow: "2px 4px 16px rgba(0, 0, 0, 0.05)",
        }}
      >
        <div className="text-[37px] font-bold text-dark1  text-center max-w-[834px]">
          Congratulations on becoming a Validator
        </div>
        <div className="mt-2 text-dark1 text-center max-w-[409px] leading-snug">
          <p>
            Your NFT will be revealed in the next few days, together with
            validator dashboard and score system.
          </p>
          <p className="mt-5">
            You will soon be able to recruit members to the network using your
            referral link and start earning Karat score and rewards.
            <Tooltip
              width={220}
              multiline
              withArrow
              events={{
                focus: true,
                hover: true,
                touch: true,
              }}
              arrowSize={10}
              classNames={{
                tooltip: "text-start",
              }}
              label="Your Karat score is calculated based on the number of referrals you have"
            >
              <span className="ml-2  inline">
                <QuestionIcon className="fill-primary w-[14px] h-[14px]  action inline"></QuestionIcon>
              </span>
            </Tooltip>
          </p>
        </div>
        <div className="w-[223px] bg-white rounded-lg mt-10 p-6">
          {/* <div className="text-center">TokenID #35</div> */}
          <img
            className="w-full mt-4 scale-[1.1]"
            src="/assets/mint/demo-id-card.png"
          ></img>
          {/* <CopyButton value={shareLink}>
            {({ copied, copy }) => (
              <div
                className="flex items-center justify-center font-medium action text-primary text-sm mt-4"
                onClick={copy}
              >
                <Add1Icon></Add1Icon>
                <span className="ml-2">
                  {copied ? "Copied 🎉" : "Copy referral link"}
                </span>
              </div>
            )}
          </CopyButton> */}
        </div>
      </div>
      <div className="flex flex-col items-center mt-10">
        {/* <div className="text-center text-sm text-dark1">
          Access your dashboard to view referrals and set network preferences.
        </div> */}

        <Button
          classNames={{
            inner: "text-body ",
            root: "w-[255px] mt-4",
          }}
          size="md"
          radius="xl"
          onClick={() => {
            window.open(`https://www.okx.com/web3?wallet=${address}`, "_blank");
          }}
        >
          View your NFT
        </Button>
      </div>
    </div>
  );
};

export default ValidatorMintResult;
